import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import api from '../../services/api';
import './AdminLogin.css'; // Importamos el CSS específico del login

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      console.log('1. Intentando login con:', email);
      
      const response = await api.post('/auth/login', { 
        email: email || 'admin@cafeelcatador.com', 
        password: password || 'admin123' 
      });
      
      console.log('2. Respuesta del servidor:', response.data);
      
      if (response.data.token) {
        // Guardar en localStorage
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        
        console.log('3. Token guardado:', response.data.token);
        console.log('4. Usuario guardado:', response.data.user);
        
        // Actualizar el contexto
        await login(email || 'admin@cafeelcatador.com', password || 'admin123');
        
        console.log('5. Redirigiendo a /admin...');
        
        // Usar navigate para redirigir
        navigate('/admin', { replace: true });
        
        // Forzar recarga después de 100ms para asegurar que el contexto se actualice
        setTimeout(() => {
          window.location.href = '/admin';
        }, 100);
      }
    } catch (err) {
      console.error('❌ Error en login:', err);
      
      if (err.code === 'ERR_NETWORK') {
        setError('No se puede conectar al servidor. Verifica que el backend esté corriendo.');
      } else if (err.response) {
        setError(err.response.data?.error || 'Credenciales inválidas');
      } else {
        setError('Error al conectar con el servidor');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-wrapper">
      <div className="admin-login-container">
        
        {/* Lado izquierdo: Branding (Visible solo en Desktop) */}
        <div className="admin-login-brand">
          <div className="brand-content">
            <span className="brand-icon">☕</span>
            <h1>Román Valderrábano</h1>
            <p className="brand-subtitle">El Catador</p>
            <p className="brand-description">Sistema de Gestión y Administración de Inventario, Ventas y Tours.</p>
          </div>
        </div>

        {/* Lado derecho: Formulario */}
        <div className="admin-login-box">
          <div className="login-header-mobile">
            <span className="brand-icon-mobile">☕</span>
            <h2>El Catador</h2>
          </div>
          
          <h2>Iniciar Sesión</h2>
          <p className="login-subtitle">Ingresa tus credenciales para acceder al panel</p>
          
          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label>Correo Electrónico</label>
              <div className="input-container">
                <span className="input-icon">📧</span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@cafeelcatador.com"
                  autoComplete="email"
                  required
                />
              </div>
            </div>
            
            <div className="form-group">
              <label>Contraseña</label>
              <div className="input-container">
                <span className="input-icon">🔒</span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  required
                />
              </div>
            </div>
            
            <button 
              type="submit" 
              className={`btn-login ${loading ? 'loading' : ''}`}
              disabled={loading}
            >
              {loading ? (
                <span className="loader-text">☕ Iniciando sesión...</span>
              ) : (
                'Acceder al Panel'
              )}
            </button>
          </form>
          
          <div className="login-info">
            <p><strong>Demo:</strong> admin@cafeelcatador.com</p>
            <p><strong>Pass:</strong> admin123</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;